define('bindingHandlers/include',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'services/loggingService',
    'util/externalInclude',
    'lib/bluebird'
], function ($, ko, _, loggingService, include, Promise) {
    'use strict';

    var TEMPLATE_CONTEXT = '_templateContext';

    function getComponentContext(element, viewModel, bindingContext) {
        var context;

        if (viewModel && viewModel[TEMPLATE_CONTEXT]){
            context = viewModel[TEMPLATE_CONTEXT];
        } else if (bindingContext) {
            _.each(bindingContext.$parents, function (parent) {
                if (parent) {
                    var templateContext = parent[TEMPLATE_CONTEXT];
                    if (templateContext) {
                        context = templateContext;
                    }
                }
            });
        }
        if (!context) {
            context = 'core';
        }
        return context;
    }

    function translateOptions(element, context, bindingData) {
        var templateName = (typeof bindingData == 'string') ? bindingData : ko.unwrap(bindingData.name);

        if (templateName && context !== 'core') {
            var componentRegex = new RegExp('^' + context + '/');
            templateName = templateName.replace(componentRegex, 'components/' + context + '/templates/');
            templateName = templateName.replace(/^core\//, 'templates/');
            if (templateName == 'main') {
                templateName = 'components/' + context + '/templates/main';
            }
        }


        return _.extend({}, bindingData, {
            name: templateName
        });
    }

    /**
     * <p>Binding handler for asynchronously loading templates.</p>
     * <p>
     *  This is a wrapper around the built in template binding, and
     *  its docs apply to this binding as well. See:<br/>
     *  {@link http://knockoutjs.com/documentation/template-binding.html}
     * </p>
     * <p>
     *   Example:<br/>
     *   <pre class="prettyprint">
     * &lt;div data-bind="tpl: {name: 'template/path', data: $data}"&gt;
     *  &lt;!-- template is rendered here --&gt;
     * &lt;/div&gt;
     *   </pre>
     * </p>
     * @exports bindingHandlers/externalTemplate
     */
    ko.bindingHandlers.include = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var
                stdTemplateInit = ko.bindingHandlers.template.init,
                self = this,
                bindingData = ko.utils.unwrapObservable(valueAccessor());

            var componentContext = getComponentContext(element, viewModel, bindingContext);
            var options = translateOptions(element, componentContext, bindingData);

            // Access data observable during binding evaluation to ensure
            // that knockout will recognize that the binding needs to be
            // re-evaluated when the data observable changes.
            if (options.data) {
                ko.unwrap(options.data);
            }

            function newValueAccessor() {
                return options;
            }

            stdTemplateInit.call(self, element, newValueAccessor, allBindings, viewModel, bindingContext);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var
                stdTemplateUpdate = ko.bindingHandlers.template.update,
                self = this,
                bindingData = ko.utils.unwrapObservable(valueAccessor());

            var componentContext = getComponentContext(element, viewModel, bindingContext);
            var options = translateOptions(element, componentContext, bindingData);

            // Access data observable during binding evaluation to ensure
            // that knockout will recognize that the binding needs to be
            // re-evaluated when the data observable changes.
            if (options.data) {
                ko.unwrap(options.data);
            }

            function newValueAccessor() {
                return options;
            }

            var templateLoadingPromise;
            if (options.name) {
                templateLoadingPromise = include.loadTemplate(options.name)
                    .cancellable()
                    .then(function () {
                        // Because this happens after the binding evaluation has
                        // gone off of the stack, we must be sure to access any
                        // observables the binding depends on before we delegate
                        // to the standard template (as above).
                        stdTemplateUpdate.call(self, element, newValueAccessor, allBindings, viewModel, bindingContext);
                    })
                    .catch(Promise.CancellationError, _.noop)
                    .catch(function (error) {
                        loggingService.trace('Failed to load template: ' + options.name, error);
                    });
            } else {
                stdTemplateUpdate.call(self, element, newValueAccessor, allBindings, viewModel, bindingContext);
            }

            // Ensure we do not load and render a template after include has been disposed.
            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                if (templateLoadingPromise && templateLoadingPromise.isPending()) {
                    templateLoadingPromise.cancel();
                }
            });
        },
        TEMPLATE_CONTEXT_KEY: TEMPLATE_CONTEXT
    };

    ko.virtualElements.allowedBindings.include = true;
    return ko.bindingHandlers.include;
});

